import { render } from "./KdInfo.vue?vue&type=template&id=40a5949a&scoped=true"
import script from "./KdInfo.vue?vue&type=script&lang=js"
export * from "./KdInfo.vue?vue&type=script&lang=js"

import "./KdInfo.vue?vue&type=style&index=0&id=40a5949a&scoped=true&lang=css"

import exportComponent from "E:\\work\\copy\\work\\fa\\tgkw\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40a5949a"]])

export default __exports__